(function () {
  'use strict';

  var TABLET_QUERY = '(max-width: 1024px)';
  var PHONE_QUERY = '(max-width: 767px)';

  function setInert(node, state) {
    if (!node) return;
    if ('inert' in node) node.inert = state;
    if (state) {
      node.setAttribute('aria-hidden', 'true');
    } else {
      node.removeAttribute('aria-hidden');
    }
  }

  function focusableWithin(node) {
    if (!node) return [];
    return Array.prototype.slice.call(node.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(function (item) {
      return !item.hidden && item.getClientRects().length > 0;
    });
  }

  function trapTab(event, container) {
    var items;
    var first;
    var last;
    if (event.key !== 'Tab') return;
    items = focusableWithin(container);
    if (!items.length) return;
    first = items[0];
    last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function directChild(parent, selector) {
    var children = parent ? parent.children : [];
    var index;
    for (index = 0; index < children.length; index += 1) {
      if (children[index].matches(selector)) return children[index];
    }
    return null;
  }

  function initializeNavigationDrawer() {
    var body = document.body;
    var toggle = document.getElementById('wsnavtoggle');
    var drawer = document.getElementById('KjsPrimaryNavigation');
    var closeButton = drawer && drawer.querySelector('.kjs-nav-close');
    var overlay = document.querySelector('.overlapblackbg');
    var container = document.querySelector('.wsmenucontainer');
    var query = window.matchMedia(TABLET_QUERY);
    var dock = document.querySelector('[data-kjs-search-dock]');
    var submenuItems = [];

    if (!toggle || !drawer || toggle.getAttribute('data-kjs-r4-bound') === 'true') return;
    toggle.setAttribute('data-kjs-r4-bound', 'true');

    Array.prototype.forEach.call(drawer.querySelectorAll('li'), function (item, index) {
      var submenu = directChild(item, 'ul');
      var link = directChild(item, 'a');
      var button;

      if (!submenu || !link) return;
      submenu.id = 'KjsR4Submenu-' + index;
      link.setAttribute('aria-haspopup', 'true');
      link.setAttribute('aria-controls', submenu.id);
      link.setAttribute('aria-expanded', 'false');

      button = directChild(item, '.kjs-submenu-toggle');
      if (!button) {
        button = document.createElement('button');
        button.type = 'button';
        button.className = 'kjs-submenu-toggle';
        button.innerHTML = '<span aria-hidden="true">+</span>';
        item.insertBefore(button, submenu);
      }
      button.setAttribute('aria-label', 'Show ' + link.textContent.trim() + ' subcategories');
      button.setAttribute('aria-controls', submenu.id);
      button.setAttribute('aria-expanded', 'false');

      function setExpanded(expanded) {
        item.classList.toggle('kjs-submenu-open', expanded);
        button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        link.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        button.setAttribute('aria-label', (expanded ? 'Hide ' : 'Show ') + link.textContent.trim() + ' subcategories');
        submenu.hidden = query.matches ? !expanded : false;
        button.querySelector('span').textContent = expanded ? '\u2212' : '+';
      }

      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        setExpanded(!item.classList.contains('kjs-submenu-open'));
      });
      submenuItems.push({ item: item, link: link, button: button, submenu: submenu, setExpanded: setExpanded });
    });

    function collapseSubmenus() {
      submenuItems.forEach(function (entry) { entry.setExpanded(false); });
    }

    function syncSubmenus() {
      if (query.matches) collapseSubmenus();
      else submenuItems.forEach(function (entry) { entry.setExpanded(false); entry.submenu.hidden = false; });
    }

    function close(restoreFocus) {
      body.classList.remove('kjs-nav-open');
      if (container) container.classList.remove('wsoffcanvasopener');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Open departments menu');
      collapseSubmenus();
      if (query.matches) setInert(drawer, true);
      if (dock) setInert(dock, false);
      if (restoreFocus) toggle.focus();
    }

    function open() {
      if (!query.matches) return;
      body.classList.add('kjs-nav-open');
      if (container) container.classList.add('wsoffcanvasopener');
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', 'Close departments menu');
      setInert(drawer, false);
      if (dock) setInert(dock, true);
      window.setTimeout(function () {
        (closeButton || focusableWithin(drawer)[0] || drawer).focus();
      }, 0);
    }

    function syncBreakpoint() {
      if (query.matches) {
        syncSubmenus();
        close(false);
      } else {
        body.classList.remove('kjs-nav-open');
        if (container) container.classList.remove('wsoffcanvasopener');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', 'Open departments menu');
        syncSubmenus();
        setInert(drawer, false);
        if (dock) setInert(dock, false);
      }
    }

    toggle.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (body.classList.contains('kjs-nav-open')) close(false);
      else open();
    }, true);
    if (closeButton) closeButton.addEventListener('click', function () { close(true); });
    if (overlay) overlay.addEventListener('click', function () { close(true); });
    drawer.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        close(true);
      } else if (body.classList.contains('kjs-nav-open')) {
        trapTab(event, drawer);
      }
    });
    drawer.addEventListener('focusin', function (event) {
      var item;
      if (query.matches) return;
      item = event.target.closest('li');
      while (item && drawer.contains(item)) {
        submenuItems.forEach(function (entry) {
          if (entry.item === item) entry.setExpanded(true);
        });
        item = item.parentElement && item.parentElement.closest('li');
      }
    });
    drawer.addEventListener('focusout', function () {
      if (query.matches) return;
      window.setTimeout(function () {
        submenuItems.forEach(function (entry) {
          if (!entry.item.contains(document.activeElement)) entry.setExpanded(false);
        });
      }, 0);
    });
    window.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && body.classList.contains('kjs-nav-open')) close(true);
    });
    if (query.addEventListener) query.addEventListener('change', syncBreakpoint);
    else query.addListener(syncBreakpoint);
    syncBreakpoint();
  }

  function initializeFilterDrawer() {
    var body = document.body;
    var toggle = document.querySelector('.template-collection .offcanvas_filter_toggle');
    var drawer = document.getElementById('KjsCollectionFilters');
    var closeButton = drawer && drawer.querySelector('.close_mobile_off_canvas');
    var overlay = document.querySelector('.template-collection .overlapblackbg_sidebar');
    var query = window.matchMedia(TABLET_QUERY);
    var dock = document.querySelector('[data-kjs-search-dock]');

    if (!toggle || !drawer || toggle.getAttribute('data-kjs-r4-bound') === 'true') return;
    toggle.setAttribute('data-kjs-r4-bound', 'true');

    function close(restoreFocus) {
      body.classList.remove('kjs-filter-open');
      var content = document.getElementById('content');
      if (content) content.classList.remove('opened_sidebar');
      toggle.setAttribute('aria-expanded', 'false');
      if (query.matches) setInert(drawer, true);
      if (dock) setInert(dock, false);
      if (restoreFocus) toggle.focus();
    }

    function open() {
      if (!query.matches) return;
      body.classList.add('kjs-filter-open');
      var content = document.getElementById('content');
      if (content) content.classList.add('opened_sidebar');
      toggle.setAttribute('aria-expanded', 'true');
      setInert(drawer, false);
      if (dock) setInert(dock, true);
      window.setTimeout(function () {
        (closeButton || focusableWithin(drawer)[0] || drawer).focus();
      }, 0);
    }

    function syncBreakpoint() {
      if (query.matches) close(false);
      else {
        body.classList.remove('kjs-filter-open');
        toggle.setAttribute('aria-expanded', 'false');
        setInert(drawer, false);
        if (dock) setInert(dock, false);
      }
    }

    toggle.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      event.stopPropagation();
      open();
    }, true);
    if (closeButton) closeButton.addEventListener('click', function (event) {
      event.preventDefault();
      close(true);
    }, true);
    if (overlay) overlay.addEventListener('click', function (event) {
      event.preventDefault();
      close(true);
    }, true);
    drawer.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        close(true);
      } else if (body.classList.contains('kjs-filter-open')) {
        trapTab(event, drawer);
      }
    });
    window.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && body.classList.contains('kjs-filter-open')) close(true);
    });
    if (query.addEventListener) query.addEventListener('change', syncBreakpoint);
    else query.addListener(syncBreakpoint);
    syncBreakpoint();
  }

  function initializeMobileBuyBar() {
    var body = document.body;
    var bar = document.querySelector('[data-kjs-mobile-buybar]');
    var sourceButton = document.getElementById('addToCart');
    var sourcePrice = document.getElementById('productPrice');
    var barButton = bar && bar.querySelector('[data-kjs-mobile-submit]');
    var barPrice = bar && bar.querySelector('[data-kjs-mobile-price]');
    var footer = document.getElementById('footer');
    var query = window.matchMedia(PHONE_QUERY);
    var observer;
    var sourceVisible = true;
    var footerVisible = false;

    if (!bar || !sourceButton || !barButton || bar.getAttribute('data-kjs-r4-bound') === 'true') return;
    bar.setAttribute('data-kjs-r4-bound', 'true');

    function setVisible(visible) {
      bar.hidden = !visible;
      body.classList.toggle('kjs-mobile-buybar-visible', visible);
    }

    function updateVisibility() {
      setVisible(query.matches && !sourceVisible && !footerVisible && !sourceButton.disabled);
    }

    function sync() {
      if (barPrice && sourcePrice) barPrice.textContent = sourcePrice.textContent.replace(/^\s+|\s+$/g, '');
      barButton.disabled = !!sourceButton.disabled;
      barButton.textContent = sourceButton.value || sourceButton.textContent || 'Add to cart';
      updateVisibility();
    }

    barButton.addEventListener('click', function () {
      if (!sourceButton.disabled) sourceButton.click();
    });

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.target === sourceButton) sourceVisible = entry.isIntersecting;
          if (entry.target === footer) footerVisible = entry.isIntersecting;
        });
        updateVisibility();
      }, { threshold: 0.15 });
      observer.observe(sourceButton);
      if (footer) observer.observe(footer);
    } else {
      window.addEventListener('scroll', function () {
        var rect = sourceButton.getBoundingClientRect();
        var footerRect = footer && footer.getBoundingClientRect();
        sourceVisible = rect.top < window.innerHeight && rect.bottom > 0;
        footerVisible = !!footerRect && footerRect.top < window.innerHeight && footerRect.bottom > 0;
        updateVisibility();
      }, { passive: true });
    }

    if ('MutationObserver' in window) {
      new MutationObserver(sync).observe(sourceButton, { attributes: true, attributeFilter: ['disabled', 'value'] });
      if (sourcePrice) new MutationObserver(sync).observe(sourcePrice, { childList: true, subtree: true, characterData: true });
    }
    if (query.addEventListener) query.addEventListener('change', sync);
    else query.addListener(sync);
    sync();
  }

  function initializeFaq() {
    var page = document.querySelector('body#frequently-asked-questions .box-page .rte');
    var headings;
    var wrapper;

    if (!page || page.getAttribute('data-kjs-faq-enhanced') === 'true') return;
    headings = Array.prototype.slice.call(page.querySelectorAll(':scope > h2'));
    if (!headings.length) return;
    page.setAttribute('data-kjs-faq-enhanced', 'true');
    wrapper = document.createElement('div');
    wrapper.className = 'kjs-faq';
    page.insertBefore(wrapper, headings[0]);

    headings.forEach(function (heading) {
      var details = document.createElement('details');
      var summary = document.createElement('summary');
      var answer = document.createElement('div');
      var next = heading.nextSibling;
      summary.textContent = heading.textContent;
      answer.className = 'kjs-faq__answer';
      while (next && !(next.nodeType === 1 && next.tagName === 'H2')) {
        var current = next;
        next = next.nextSibling;
        answer.appendChild(current);
      }
      details.appendChild(summary);
      details.appendChild(answer);
      wrapper.appendChild(details);
      heading.parentNode.removeChild(heading);
    });
  }

  function initializeRelease4() {
    if (!document.body || document.body.getAttribute('data-kjs-ui') !== '4') return;
    initializeNavigationDrawer();
    initializeFilterDrawer();
    initializeMobileBuyBar();
    initializeFaq();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeRelease4);
  } else {
    initializeRelease4();
  }
  document.addEventListener('shopify:section:load', initializeRelease4);
}());

